module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aqpjX"))).then(() => parcelRequire('5erN3'));